import { LayoutType, ResponsibleLayoutsType } from '@/components/DynamicForm/types/DynamicFormTypes';

export const applyLayoutStyles = (definedStyles = {}, layout?: LayoutType | ResponsibleLayoutsType) => {
	if (!layout || Object.keys(layout).length === 0) {
		return definedStyles;
	}

	if (isResponsibleLayoutsType(layout)) {
		const breakpoints = ['xs', 'md', 'lg'] as const;
		const finalStyles: Record<string, Record<string, unknown>> = {};

		breakpoints.forEach((bp) => {
			if (layout[bp]) {
				const partialStyles = getLayoutStylesObject(layout[bp]);
				Object.keys(partialStyles).forEach((cssProp) => {
					if (!finalStyles[cssProp]) {
						finalStyles[cssProp] = {};
					}
					finalStyles[cssProp][bp] = partialStyles[cssProp];
				});
			}
		});

		return {
			...definedStyles,
			...finalStyles,
		};
	} else {
		return {
			...definedStyles,
			...getLayoutStylesObject(layout),
		};
	}
};

const getLayoutStylesObject = (layout?: LayoutType): Record<string, unknown> => {
	if (!layout || Object.keys(layout).length === 0) {
		return {};
	}

	const newStyles = {
		justifyContent: layout.justify ?? '',
	};

	const isGrid = layout.arrange === 'stacked' || layout.arrange === 'stacked-reverse';

	if (isGrid) {
		if (layout.columns && layout.columns >= 2) {
			return {
				...newStyles,
				display: 'grid',
				gridTemplateColumns: `repeat(${layout.columns || 1}, 1fr)`,
			};
		}

		return {
			...newStyles,
			display: 'flex',
			flexDirection: layout.arrange === 'stacked-reverse' ? 'column-reverse' : 'column',

			'&>*': {
				width: '100%',
			},
		};
	} else {
		return {
			...newStyles,
			display: 'flex',
			flexDirection: layout.arrange === 'inline-reverse' ? 'row-reverse' : 'row',
			flexWrap: 'nowrap',

			'&>*': {
				width: 'auto',
			},
		};
	}
};

const isResponsibleLayoutsType = (layout: LayoutType | ResponsibleLayoutsType): layout is ResponsibleLayoutsType => {
	return layout !== undefined && ('xs' in layout || 'md' in layout || 'lg' in layout);
};
